import React, { useEffect, useState, useRef, useMemo } from "react";
import "react-simple-keyboard/build/css/index.css";
//import { bannerList } from "../../config/game-configs";
import moment from "moment";
import useCountDown from 'react-countdown-hook';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PinInput from "react-pin-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalBody
} from "reactstrap";
import SecureLS from "secure-ls";
import {
  setBusy,
  setDisplayLogin,
  setDisplayRegister,
  setDisplayForgotPassword,
  setIdle,
  showMessage,
  showResponseMessage,
  setDisplayProfile,
  setUnclaimCommission,
  setGrandTotalRewards,
  setGamePoints,
  checkMemberDownlineDeposit,
  handleTelegramBannerOnClick
} from "../../redux/AppAction";
import { startGame } from "../../redux/GameAction.js";
import { performLogin, updateUserWalletBalance, updateUserLoyaltyPoints } from "../../redux/AuthAction.js";
import { AlertTypes, ApiKey, ApiUrl, PhoneNumberPrefix, SessionKey, WebUrl, LanguageOption, getHostnameReferralCode } from "../../util/Constant";
import ApiEngine from "./../../util/ApiEngine.js";
import {
  createFormBody,
  createMultiPartFormBody,
  stringIsNullOrEmpty,
  numberWithCurrencyFormat2,
  numberWithCurrencyFormat
} from "./../../util/Util.js";
import parse from 'react-html-parser';
import { bool } from "prop-types";
import Input from "../../components/custom/Input";
import { isUndefined, size, map } from "lodash";
import ProfileDetail from "../my-profile/ProfileDetail";
import ChangePassword from "../my-profile/changePassword";
import ChangeShareHolderPin from "../my-profile/changeShareHolderPin";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import Slider from "react-slick";


const openEye = "/img/ug/auth/show.svg";
const closedEye = "/img/ug/auth/hide.svg";
const purpleBg = "/img/ug/auth/register-modal-left-bg.jpg";
const refreshIconStatic = "/img/ug/auth/spin-refresh-icon-static.png";
const CompleteIcon = "/img/ug/auth/complete_Icon.gif";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const Auth = () => {
  const { t, i18n } = useTranslation();
  const _history = useHistory();
  const _dispatch = useDispatch();
  var ls = new SecureLS();
  const _MIN_PASSWORD_LENGTH = 6;
  const _TAC_VALID_TIMER = 300000;
  const _SECONDS_IN_MS = 1000;
  const _TAC_TIMEOUT_IN_MINUTES = 5;
  const initialTime = 120 * 1000;
  const interval = 1000;
  const [isForgetPassword, setIsForgetPassword] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [countdownTime, { start, pause, resume, reset }] = useCountDown(initialTime, interval);
  const _userData = useSelector((state) => state.authState.userData);

  /* control display login and register*/
  const { isLoggedIn } = useSelector((state) => state.authState);
  let isShowLogin = useSelector((state) => state.appState.isShowLogin);
  let isShowRegister = useSelector((state) => state.appState.isShowRegister);
  let isShowForgotPassword = useSelector((state) => state.appState.isShowForgotPassword);
  let isShowProfile = useSelector((state) => state.appState.isShowProfile);
  let isShareholder = useSelector((state) => state.appState.isShareholder);
  let unclaimCommission = useSelector((state) => state.appState.unclaimCommission);
  let grandTotalRewards = useSelector((state) => state.appState.grandTotalRewards);
  const telegramBotStatus = useSelector((state) => state.appState.telegramBotStatus);
  const telegramBanners = useSelector((state) => state.appState.telegramBannerSecondary);

  const [enteredPinNumber, setEnteredPinNumber] = useState("");
  const [forgetPasswordcountdownTAC, setCountdownTAC] = useState(false);

  /*  login component */
  const [isHiddenLoginPassword, setIsHiddenLoginPassword] = useState(closedEye);
  const [loginPasswordVisible, setLoginPasswordVisible] = useState(false);

  /*  forgot password*/
  const [verifyPhoneTAC, setVerifyPhoneTAC] = useState(false);
  const [isUpdatePassword, setIsUpdatePassword] = useState(false);
  const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);

  const [isHiddenResetPassword, setIsHiddenResetPassword] = useState(closedEye);
  const [isHiddenResetConfirmPassword, setIsHiddenResetConfirmPassword] = useState(closedEye);
  const [newResetPasswordVisible, setNewResetPasswordVisible] = useState(false);
  const [confirmResetPasswordVisible, setConfirmResetPasswordVisible] = useState(false);


  const [referralCode, setReferralCode] = useState("");
  const [TACcountdownPeriod, setTACCountdownPeriod] = useState(0);
  const [countdownPeriod, setCountdownPeriod] = useState(0);


  const [TACtimer, setTACtimer] = useState(setTimeout(() => { }, 100000));
  const [username, setUsername] = useState("");
  const [tempPhoneNum, setTempPhoneNum] = useState("");
  const [registerPopupContent, setRegisterPopupContent] = useState("");
  const [tabDownlineActive, setTabDownlineActive] = useState(1);
  const [isCheckingReferral, setIsCheckingReferral] = useState(false);

  const gifSrc = useMemo(() => `${CompleteIcon}?t=${new Date().getTime()}`, []);

  const [refreshWalletBalanceIsSpining, setRefreshWalletBalanceIsSpining] = useState(false);
  const [refreshWalletBalanceSpin, setRefreshWalletBalanceSpin] = useState(false);

  const [refreshUnclaimCommissionIsSpining, setRefreshUnclaimCommissionIsSpining] = useState(false);
  const [refreshUnclaimCommissionSpin, setRefreshUnclaimCommissionSpin] = useState(false);

  const [refreshRewardIsSpining, setRefreshRewardIsSpining] = useState(false);
  const [refreshRewardSpin, setRefreshRewardSpin] = useState(false);

  const [refreshLoyaltyPointsIsSpining, setRefreshLoyaltyPointsIsSpining] = useState(false);
  const [refreshLoyaltyPointsSpin, setRefreshLoyaltyPointsSpin] = useState(false);

  const bannerSlickSlidesToShow = 1;

  const telegramBannerSlick = {
    slidesToShow: bannerSlickSlidesToShow,
    slidesToScroll: bannerSlickSlidesToShow,
    dots: false,
    lazyLoad: true,
    arrows: false,
    swipe: true,
    infinite: telegramBanners > bannerSlickSlidesToShow ? true : false,
    swipeToSlide: true,
    speed: 1000,
    autoplay: true,
  };

  const noticeIcons = [
    {
      id: 1,
      image: "/img/live-ui/notice2.svg",
      link: WebUrl._URL_REFERRAL_CODE_UG,
      name: "REFERRAL"
    },
    {
      id: 2,
      image: "/img/live-ui/notice4.svg",
      link: WebUrl._URL_NOTIFICATION,
      name: "NOTIFICATION"
    },
    {
      id: 2,
      image: "/img/v3/downline.svg",
      link: WebUrl._URL_DOWNLINE_UG,
      name: "DOWNLINE"
    },
  ];

  const walletInfo = [
    {
      id: 1,
      name: "MAIN_WALLET",
      balance: isLoggedIn && _userData && _userData.walletBalance ? " " + numberWithCurrencyFormat2(parseFloat(_userData.walletBalance), 2, true) + " " : "0.00",
      url: "",
      isCurrency: true,
      refreshWalletIsSpining: refreshWalletBalanceIsSpining,  // Example state
      refreshBalanceSpin: refreshWalletBalanceSpin,      // Example state
      refreshIconStatic: refreshIconStatic, // Example icon path
      CompleteIcon: CompleteIcon    // Example complete icon path
    },
    {
      id: 1,
      name: "COMMISSION",
      balance: isLoggedIn ? numberWithCurrencyFormat(unclaimCommission, 3, true) : "0.000",
      url: WebUrl._URL_UNCLAIM_COMMISSION_HISTORY,
      isCurrency: true,
      refreshWalletIsSpining: refreshUnclaimCommissionIsSpining,  // Example state
      refreshBalanceSpin: refreshUnclaimCommissionSpin,      // Example state
      refreshIconStatic: refreshIconStatic, // Example icon path
      CompleteIcon: CompleteIcon    // Example complete icon path
    },
    {
      id: 1,
      name: "REWARDS",
      balance: isLoggedIn ? numberWithCurrencyFormat(grandTotalRewards, 3, true) : "0.000",
      url: WebUrl._URL_REWARDS,
      isCurrency: true,
      refreshWalletIsSpining: refreshRewardIsSpining,  // Example state
      refreshBalanceSpin: refreshRewardSpin,      // Example state
      refreshIconStatic: refreshIconStatic, // Example icon path
      CompleteIcon: CompleteIcon    // Example complete icon path
    },
    {
      id: 1,
      name: "LOYALTY",
      balance: isLoggedIn ? numberWithCurrencyFormat(_userData.loyaltyPoints, 3, true) : "0.0000",
      url: WebUrl._URL_LOYALTY_REDEMPTION,
      isCurrency: false,
      refreshWalletIsSpining: refreshLoyaltyPointsIsSpining,  // Example state
      refreshBalanceSpin: refreshLoyaltyPointsSpin,      // Example state
      refreshIconStatic: refreshIconStatic, // Example icon path
      CompleteIcon: CompleteIcon    // Example complete icon path
    },
  ]

  const verifyState = {
    button: "1"
  };

  const TabDownline = [
    {
      id: 1,
      title: "DETAIL",
      isShareHolder: false,
    },
    {
      id: 2,
      title: "CHANGE_PASSWORD",
      isShareHolder: false,
    },
    {
      id: 3,
      title: "CHANGE_SHAREHOLDER_PIN",
      isShareHolder: true,
    }
  ]

  const {
    register: registerLogin,
    handleSubmit: handleSubmitLogin,
    setValue: setValueLogin,
    getValues: getValuesLogin,
    watch: watchLogin,
    errors: errorsLogin,
  } = useForm();

  const {
    register: checkReferralRegister,
    handleSubmit: handleSubmitCheckReferral,
    errors: checkReferralErrors,
    unregister: checkReferralUnregister,
    reset: resetCheckReferralRegister
  } = useForm();

  const {
    register: forgotPasswordRegister,
    handleSubmit: forgotPasswordHandleSubmit,
    errors: forgotPasswordErrors,
    unregister: forgotPasswordUnregister
  } = useForm();

  const {
    register: tacVerifyRegister,
    handleSubmit: tacVerifyHandleSubmit,
    unregister: tacVerifyUnregister
  } = useForm();

  const {
    register: ResetPasswordRegister,
    handleSubmit: ResetPasswordHandleSubmit,
    errors: ResetPasswordErrors,
    watch: ResetPasswordWatch,
    setValue: ResetPasswordSetValue,
    unregister: ResetPasswordUnregister,
    watch,
  } = useForm();

  //use effect function start region ---------------------------------------------------------------------

  //trigger after send TAC request count down period
  useEffect(() => {
    if (countdownPeriod > 0) {
      setTimeout(() => {
        let tempPeriod = countdownPeriod - 1;
        setCountdownPeriod(tempPeriod);
      }, _SECONDS_IN_MS);
      // }, 10);
    }
  }, [countdownPeriod]);


  //trigger TAC valid count down period
  useEffect(() => {
    if (TACcountdownPeriod > 0) {
      setTACtimer(setTimeout(() => {
        let tempPeriod = TACcountdownPeriod - 1;
        setTACCountdownPeriod(tempPeriod);
      }, _SECONDS_IN_MS));
      // }, 10));
    }
  }, [TACcountdownPeriod]);

  //trigger Check Member downline
  useEffect(() => {
    if (isLoggedIn) {
      _dispatch(checkMemberDownlineDeposit());
    }
    if (isLoggedIn && isShowProfile) {
      getUnclaimCommHistory();
      getRewardData();
    }
  }, [isLoggedIn, isShowProfile]);

  //use effect function end region ---------------------------------------------------------------------


  //api function start region ---------------------------------------------------------------------

  const updateMemberWalletBalance = async () => {
    if (!refreshWalletBalanceIsSpining && !refreshWalletBalanceSpin) {
      setRefreshWalletBalanceIsSpining(true);
      let walletResponse = await ApiEngine.get(ApiUrl._API_GET_MEMBER_WALLET_BALANCE);
      if (walletResponse[ApiKey._API_SUCCESS_KEY]) {
        let data = walletResponse[ApiKey._API_DATA_KEY];
        _dispatch(updateUserWalletBalance(data));
        if (!refreshWalletBalanceSpin) {
          setRefreshWalletBalanceSpin(true);
          setTimeout(() => setRefreshWalletBalanceSpin(false), [5000]);
        }
        setRefreshWalletBalanceIsSpining(false);
      } else {
        setRefreshWalletBalanceIsSpining(false);
      }
    }
  }

  const updateMemberLoyaltyPoints = async () => {
    if (!refreshLoyaltyPointsIsSpining && !refreshLoyaltyPointsSpin) {
      setRefreshLoyaltyPointsIsSpining(true);
      let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_LOYALTY_POINTS_BY_ID);

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        _dispatch(updateUserLoyaltyPoints(responseJson[ApiKey._API_DATA_KEY]));
        if (!refreshLoyaltyPointsSpin) {
          setRefreshLoyaltyPointsSpin(true);
          setTimeout(() => setRefreshLoyaltyPointsSpin(false), [5000]);
        }
        setRefreshLoyaltyPointsIsSpining(false);
      } else {
        setRefreshLoyaltyPointsIsSpining(false);
      }
    }
  }

  const updateMemberUnclaimCommission = async () => {
    if (!refreshUnclaimCommissionIsSpining && !refreshUnclaimCommissionSpin) {
      setRefreshUnclaimCommissionIsSpining(true);
      var responseJson = await ApiEngine.get(ApiUrl._API_GET_UNCLAIM_COMMISSION_AMT);
      if (responseJson[ApiKey._API_SUCCESS_KEY] && responseJson[ApiKey._API_DATA_KEY] != null) {
        _dispatch(setUnclaimCommission(responseJson[ApiKey._API_DATA_KEY]));
        if (!refreshUnclaimCommissionSpin) {
          setRefreshUnclaimCommissionSpin(true);
          setTimeout(() => setRefreshUnclaimCommissionSpin(false), [5000]);
        }
        setRefreshUnclaimCommissionIsSpining(false);
      } else {
        setRefreshUnclaimCommissionIsSpining(false);
      }
    }
  }


  const updateMemberRewardData = async () => {
    if (!refreshRewardIsSpining && !refreshRewardSpin) {
      setRefreshRewardIsSpining(true);
      let responseJson = await ApiEngine.get(
        ApiUrl._API_GET_CATEGORY_REWARD_RATES + "?all=true"
      );

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        let data = responseJson[ApiKey._API_DATA_KEY];
        let tempObj = {};
        let grandTotalReward = 0;
        let categoryTotal = {};
        data.map((rewardData, index) => {
          if (!tempObj[rewardData["date"]]) {
            tempObj[rewardData["date"]] = { totalAmount: 0, totalAmountClaimable: 0 };
          }
          if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]]) {
            tempObj[rewardData["date"]][rewardData["categoryTitle"]] = { totalAmount: 0, totalAmountClaimable: 0 };
          }
          if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]]) {
            tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]] = { productImage: rewardData["productImage"], rate: rewardData["rewardRate"] };
          }
          tempObj[rewardData["date"]].totalAmount += rewardData["amount"];
          tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
          if (rewardData["claimed"] !== "True") {
            tempObj[rewardData["date"]].totalAmountClaimable += rewardData["amount"];
            tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmountClaimable += rewardData["amount"];
            grandTotalReward += rewardData["amount"];

            if (!categoryTotal[rewardData["categoryTitle"]]) {
              categoryTotal[rewardData["categoryTitle"]] =
              {
                category: rewardData["categoryTitle"],
                totalAmount: rewardData["amount"]
              };
            }
            else if (categoryTotal[rewardData["categoryTitle"]]) {
              categoryTotal[rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
            }
            else if (categoryTotal[rewardData["categoryTitle"]]) {
              categoryTotal[rewardData["categoryTitle"]] =
              {
                category: rewardData["categoryTitle"],
                totalAmount: rewardData["amount"]
              };
            }
          }

        });
        _dispatch(setGrandTotalRewards(grandTotalReward));
        if (!refreshRewardSpin) {
          setRefreshRewardSpin(true);
          setTimeout(() => setRefreshRewardSpin(false), [5000]);
        }
        setRefreshRewardIsSpining(false);
      } else {
        _dispatch(
          showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
        );
        setRefreshRewardIsSpining(false);
      }
    }
  }


  const getRewardData = async () => {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_CATEGORY_REWARD_RATES + "?all=true"
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      let tempObj = {};
      let grandTotalReward = 0;
      let categoryTotal = {};
      data.map((rewardData, index) => {
        if (!tempObj[rewardData["date"]]) {
          tempObj[rewardData["date"]] = { totalAmount: 0, totalAmountClaimable: 0 };
        }
        if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]]) {
          tempObj[rewardData["date"]][rewardData["categoryTitle"]] = { totalAmount: 0, totalAmountClaimable: 0 };
        }
        if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]]) {
          tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]] = { productImage: rewardData["productImage"], rate: rewardData["rewardRate"] };
        }
        tempObj[rewardData["date"]].totalAmount += rewardData["amount"];
        tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
        if (rewardData["claimed"] !== "True") {
          tempObj[rewardData["date"]].totalAmountClaimable += rewardData["amount"];
          tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmountClaimable += rewardData["amount"];
          grandTotalReward += rewardData["amount"];

          if (!categoryTotal[rewardData["categoryTitle"]]) {
            categoryTotal[rewardData["categoryTitle"]] =
            {
              category: rewardData["categoryTitle"],
              totalAmount: rewardData["amount"]
            };
          }
          else if (categoryTotal[rewardData["categoryTitle"]]) {
            categoryTotal[rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
          }
          else if (categoryTotal[rewardData["categoryTitle"]]) {
            categoryTotal[rewardData["categoryTitle"]] =
            {
              category: rewardData["categoryTitle"],
              totalAmount: rewardData["amount"]
            };
          }
        }

      });
      _dispatch(setGrandTotalRewards(grandTotalReward));
    } else {
      _dispatch(
        showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
      );
    }
  }

  const getUnclaimCommHistory = async () => {
    var responseJson = await ApiEngine.get(ApiUrl._API_GET_UNCLAIM_COMMISSION_AMT);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      _dispatch(setUnclaimCommission(responseJson[ApiKey._API_DATA_KEY]));
    }
  };


  //submit login 
  const submitLoginForm = async (data, e) => {
    _dispatch(setBusy());
    localStorage.setItem(SessionKey._ISSHOWMINIGAMETRIGGER, true);
    _dispatch(setDisplayLogin(false));
    if (data.isKeepedPassword) {
      ls.set("gR97lPRIn797", {
        Do3SwI4cuvqR: data.loginUsername,
        gR1IPGBN01dS: data.loginPassword,
        PYTLczcty9uH: data.isKeepedPassword,
      });
    } else {
      ls.set("gR97lPRIn797", {
        Do3SwI4cuvqR: "",
        gR1IPGBN01dS: "",
        PYTLczcty9uH: false,
      });
    }
    await _dispatch(
      performLogin(data.loginUsername, data.loginPassword, data.isKeepedLogin)
    );
    let params = {
      username: data.loginUsername,
    };
    _dispatch(setIdle());
  }

  //check referral exist

  async function submitCheckReferralCode() {
    setIsCheckingReferral(true);
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_UPLINE_BY_REFERRAL_CODE + "?code=" + referralCode
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      _history.push(WebUrl._URL_REGISTER + "?code=" + referralCode);
      setIsCheckingReferral(false);
      handleCloseRegisterModal();
      resetCheckReferralRegister();
    } else {
      _dispatch(
        showMessage({
          type: AlertTypes._ERROR,
          content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
        })
      );
      setIsCheckingReferral(false);
      setReferralCode("");
    }
  }

  //submit forgot password
  async function submitForgotPasswordForm(data) {

    _dispatch(setBusy());
    let formData = {
      "language": i18n.language,
      "username": data.username
    };
    let formBody = createMultiPartFormBody(formData);
    var responseJson = await ApiEngine.post(
      ApiUrl._API_SEND_RESET_PASSWORD_SMS,
      formBody
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setUsername(data.username)
      //setPhoneNumber(responseJson.data)
      setTempPhoneNum(responseJson.data)
      setVerifyPhoneTAC(true)
      setIsForgetPassword(false)
      setTimeout(() => {
        setCountdownTAC(true)
      }, 120000);
      start();
      //resetForm();
    }
    else {
      _dispatch(showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY]))
    }
    _dispatch(setIdle());
  }
  async function submitVerifyTAC(data) {
    _dispatch(setBusy());
    if (verifyState.button == 1) {

      let formData = {
        "taccode": enteredPinNumber,
        "username": username
      };
      let formBody = createMultiPartFormBody(formData);
      let TACjson = await ApiEngine.post(
        ApiUrl._API_VERIFY_RESET_PASSWORD_SMS,
        formBody
      );
      if (TACjson[ApiKey._API_SUCCESS_KEY]) {
        setVerifyPhoneTAC(false)
        setIsUpdatePassword(true)
        //resetForm();
      }
    } else if (verifyState.button == 2) {
      let formData = {
        "language": i18n.language,
        "username": username
      };
      let formBody = createMultiPartFormBody(formData);
      //data["phoneNumber"] = formattedPhoneNumber;
      data["language"] = i18n.language;
      var responseJson = await ApiEngine.post(
        ApiUrl._API_SEND_RESET_PASSWORD_SMS,
        formBody
      );

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        setCountdownTAC(false)
        setUsername(username)
        //setPhoneNumber(responseJson.data)
        setTempPhoneNum(responseJson.data)
        setVerifyPhoneTAC(true)
        setIsForgetPassword(false)
        setTimeout(() => {
          setCountdownTAC(true)
        }, 120000);
        reset();
        start();
        //resetForm();
      }
    }

    _dispatch(setIdle());
  }

  async function submitNewPassword(data) {
    _dispatch(setBusy());
    let formData = {
      "tacCode": enteredPinNumber,
      "newpassword": data.newPassword,
      "confpassword": data.confPassword,
      "username": username,

    };
    let formBody = createMultiPartFormBody(formData);

    var responseJson = await ApiEngine.post(
      ApiUrl._API_MEMBER_RESET_PASSWORD_BEFORE_LOGIN,
      formBody
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setIsUpdatePassword(false)
      setIsPasswordUpdated(true)
    }
    _dispatch(setIdle());
  }


  //api function end region ---------------------------------------------------------------------

  //normal function start region ---------------------------------------------------------------------
  const toggleHiddenLoginPassword = () => {
    setLoginPasswordVisible(!loginPasswordVisible);
    if (isHiddenLoginPassword === closedEye) {
      setIsHiddenLoginPassword(openEye);
    } else {
      setIsHiddenLoginPassword(closedEye);
    }
  };

  const toggleHiddenResetPassword = () => {
    setNewResetPasswordVisible(!newResetPasswordVisible);
    if (isHiddenResetPassword === closedEye) {
      setIsHiddenResetPassword(openEye);
    } else {
      setIsHiddenResetPassword(closedEye);
    }
  };

  const toggleHiddenResetConfirmPassword = () => {
    setConfirmResetPasswordVisible(!confirmResetPasswordVisible);
    if (isHiddenResetConfirmPassword === closedEye) {
      setIsHiddenResetConfirmPassword(openEye);
    } else {
      setIsHiddenResetConfirmPassword(closedEye);
    }
  };

  const handleReferralCode = (code) => {
    setReferralCode(code);
  };

  const handleCloseRegisterModal = () => {
    _dispatch(setDisplayRegister(false));
    setReferralCode("");
  }

  const handleCloseLoginModal = () => {
    _dispatch(setDisplayLogin(false));
  }

  const handleCloseForgotPasswordModal = () => {
    _dispatch(setDisplayForgotPassword(false));
    setIsForgetPassword(false);
    setVerifyPhoneTAC(false);
    setIsUpdatePassword(false);
    setIsPasswordUpdated(false);
    setIsLogin(true);
  }

  const handleCloseRegisterAndOpenSignInModal = () => {
    _dispatch(setDisplayRegister(false));
    setReferralCode("");
    _dispatch(setDisplayLogin(true));

  }

  const handleCloseProfileModal = () => {
    _dispatch(setDisplayProfile(false));
  }

  const handleWalletClick = (item) => {
    if (!stringIsNullOrEmpty(item.url)) {
      _history.push(item.url);
      _dispatch(setDisplayProfile(false));
    }
  }

  const handleBannerOnClick = async (bannerUrl) => {
    if (!stringIsNullOrEmpty(bannerUrl) && bannerUrl !== "#") {
      if (bannerUrl.startsWith("Game/StartGame?gameId=")) {
        if (isLoggedIn) {
          let game = bannerUrl.match("gameId=(.*)&isApp=");
          let gameId = game[1];
          var newResponseJson = await ApiEngine.get(
            ApiUrl._API_GET_PRODUCT_GAME_BY_GAME_ID + "?id=" + gameId
          );

          if (newResponseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = newResponseJson[ApiKey._API_DATA_KEY];
            if (data != null) {
              _dispatch(startGame(data));
            }
          }
        }
        else {
          // eslint-disable-next-line no-undef
          _dispatch(
            showMessage({
              type: AlertTypes._INFO,
              content: t("PLEASE_LOGIN_FIRST"),
              onConfirm: () => {
              },
            })
          );
        }
      } else {
        const isExternal = bannerUrl.startsWith('http://') || bannerUrl.startsWith('https://');
        if (isExternal) {
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                url: /(http(s?)):\/\//i.test(bannerUrl) ? bannerUrl : window.location.origin + "/" + bannerUrl,
              }));
          } else {
            window.open(bannerUrl);
          }

          window.open(bannerUrl, '_blank');
        } else {
          _history.push(bannerUrl);
        }
      }
    }
  }

  //normal function end region ---------------------------------------------------------------------

  return (
    <>
      <Modal
        isOpen={(isShowRegister || isShowLogin || isShowForgotPassword) && !isLoggedIn}
        className="auth-register-popup-modal"
        toggle={() => {
          handleCloseRegisterModal();
          handleCloseLoginModal();
          handleCloseForgotPasswordModal();
        }}
        fade={false}
      >
        <ModalBody>
          <div className="register-popup-wrapper">
            {!(isShowRegister && !isLoggedIn) &&
              <div className={"custom-register-close-modal"}>
                <div
                  className="custom-close-button"
                  onClick={() => {
                    handleCloseRegisterModal()
                    handleCloseLoginModal();
                    handleCloseForgotPasswordModal();
                  }}
                >
                  <img
                    src={"/img/ug/auth/modal-close.png"}
                    alt="close"
                  />
                </div>
                <div>
                  {isShowRegister && !isLoggedIn && t("REGISTER")}
                  {isShowLogin && !isLoggedIn && t("LOGIN")}
                  {isShowForgotPassword && !isLoggedIn && isForgetPassword && t("FORGOT_PASSWORD")}
                  {isShowForgotPassword && !isLoggedIn && verifyPhoneTAC && t("VERIFY_YOUR_NUMBER")}
                  {isShowForgotPassword && !isLoggedIn && isUpdatePassword && t("RESET_YOUR_PASSWORD")}
                  {isShowForgotPassword && !isLoggedIn && isPasswordUpdated && t("COMPLETE_RESET_PASSWORD")}
                </div>
              </div>
            }


            {isShowRegister && !isLoggedIn &&
              <>
                <div className="top" style={{ backgroundImage: "url(" + purpleBg + ")" }}>
                  <div className={"custom-register-close-modal active"}>
                    <div
                      className="custom-close-button"
                      onClick={() => {
                        handleCloseRegisterModal()
                        handleCloseLoginModal();
                        handleCloseForgotPasswordModal();
                      }}
                    >
                      <img
                        src={"/img/ug/auth/modal-close.png"}
                        alt="close"
                      />
                    </div>
                    <div>
                      {isShowRegister && !isLoggedIn && t("REGISTER")}
                      {isShowLogin && !isLoggedIn && t("LOGIN")}
                      {isShowForgotPassword && !isLoggedIn && isForgetPassword && t("FORGOT_PASSWORD")}
                      {isShowForgotPassword && !isLoggedIn && verifyPhoneTAC && t("VERIFY_YOUR_NUMBER")}
                      {isShowForgotPassword && !isLoggedIn && isUpdatePassword && t("RESET_YOUR_PASSWORD")}
                      {isShowForgotPassword && !isLoggedIn && isPasswordUpdated && t("COMPLETE_RESET_PASSWORD")}
                    </div>
                  </div>
                  <div className="left-section">
                    <h2 className="left-section-title">{t("AUTH_HOW_TO_GET_REFERRAL_CODE")}</h2>
                    <ol className="left-section-list">
                      <li className="left-section-list-item">
                        <div className="left-section-list-number">1</div>
                        <span>{t("AUTH_REFERRAL_BULLET_1")}</span>
                      </li>
                      <li className="left-section-list-item">
                        <div className="left-section-list-number">2</div>
                        <span>{t("AUTH_REFERRAL_BULLET_2")}</span>
                      </li>
                      <li className="left-section-list-item">
                        <div className="left-section-list-number">3</div>
                        <span>{t("AUTH_REFERRAL_BULLET_3")}</span>
                      </li>
                      <li className="left-section-list-item">
                        <div className="left-section-list-number">4</div>
                        <span>{t("AUTH_REFERRAL_BULLET_4")}</span>
                      </li>
                    </ol>

                    <div className="left-section-tips">
                      <span>
                        {t("AUTH_REFERRAL_TIPS")}
                      </span>
                    </div>

                    <div className="left-section-footer">
                      <div>{t("AUTH_MIN_DEPOSIT")}</div>
                      <div>{t("AUTH_MIN_WITHDRAWAL")}</div>
                    </div>
                  </div>
                </div>
                <div className="bottom">
                  <form onSubmit={handleSubmitCheckReferral(submitCheckReferralCode)} style={{ width: '100%', alignSelf: 'center' }}>
                    <div className="referral-code-tips">
                      {t("PLEASE_ENTER_UPLINE_CODE")}
                      {/* <div>{t("EXAMPLE_SHORT") + "AbCd3fGH +"}</div> */}
                    </div>
                    <input
                      className="custom-input-style-1"
                      type="text"
                      name="referralCode"
                      placeholder="eg. AbCd3fGH +"
                      ref={checkReferralRegister({
                        required: "FIELD_REQUIRED",
                      })}
                      onChange={(e) => handleReferralCode(e.target.value)}
                      disabled={isCheckingReferral}
                      errors={checkReferralErrors}
                      value={referralCode}
                    />

                    <div className="referral-code-desc">
                      <span style={{ color: "red" }}>*</span>{t("AUTH_REFERRAL_CODE_DESC")}
                    </div>

                    {checkReferralErrors.referralCode && (
                      <div className="invalid-feedback">
                        {t(checkReferralErrors.referralCode.message)}
                      </div>
                    )}
                    {!stringIsNullOrEmpty(registerPopupContent) && <div className="referral-code-text">
                      <span className="color-red">*</span>{parse(registerPopupContent)}
                    </div>}
                    <button
                      className="custom-btn-style-1"
                      type="submit"
                      disabled={isCheckingReferral}
                    >
                      {isCheckingReferral ? t("CHECKING_REFERRAL") + "..." : t("REGISTER")}
                    </button>

                    <div className="referral-code-sign-in">
                      <div className="sign-in-desc">{t("AUTH_REFERRAL_CODE_HAVE_AN_ACCOUNT")}</div>
                      <div
                        className="sign-in-link"
                        onClick={() => handleCloseRegisterAndOpenSignInModal()}
                      > {t("AUTH_SIGN_IN")}
                      </div>
                    </div>
                  </form>
                </div>


              </>
            }


            {isShowLogin && !isLoggedIn &&
              <>
                <div className="auth-right-container">
                  <form onSubmit={handleSubmitLogin(submitLoginForm)}>
                    <div className="font-16 mt-3">
                      {t("USERNAME")}
                    </div>
                    <input
                      type="text"
                      name="loginUsername"
                      id="loginUsername"
                      className="login-username custom-input-style-1"
                      placeholder={t("USERNAME")}
                      autoComplete="off"
                      defaultValue={ls.get("gR97lPRIn797")["Do3SwI4cuvqR"]}
                      ref={registerLogin({
                        required: true,
                      })}
                      errors={errorsLogin}
                    />
                    {errorsLogin.loginUsername && (
                      <div className="invalid-feedback">
                        {t(errorsLogin.loginUsername.message)}
                      </div>
                    )}
                    <div className="font-16 mt-3">
                      {t("PASSWORD")}
                    </div>
                    <div className="input-with-icon-container">
                      <input
                        type={loginPasswordVisible ? "text" : "password"}
                        name="loginPassword"
                        id="loginPassword"
                        className="login-password custom-input-style-1"
                        placeholder={t("PASSWORD")}
                        defaultValue={ls.get("gR97lPRIn797")["gR1IPGBN01dS"]}
                        autoComplete="off"
                        ref={registerLogin({
                          required: true,
                        })}
                        errors={errorsLogin}
                      />
                      {errorsLogin.loginPassword && (
                        <div className="invalid-feedback">
                          {t(errorsLogin.loginPassword.message)}
                        </div>
                      )}
                      <div className="input-hidden-icon" onClick={toggleHiddenLoginPassword}>
                        <img src={isHiddenLoginPassword} alt="password" className="img-responsive" />
                      </div>
                    </div>
                    <div className="login-checkbox-btn-wrapper mt-3">
                      <div className="login-keep-logged-in checkbox-wrapper">
                        <input
                          type="checkbox"
                          name="isKeepedLogin"
                          ref={registerLogin()}
                          errors={errorsLogin}
                        />
                        <span>{t("KEEP_LOGGED_IN")}</span>
                      </div>
                      <div className="login-remember-password checkbox-wrapper">
                        <input
                          type="checkbox"
                          name="isKeepedPassword"
                          ref={registerLogin()}
                          errors={errorsLogin}
                          defaultChecked={ls.get("gR97lPRIn797")["PYTLczcty9uH"]}
                        />
                        <span>{t("KEEP_PASSWORD")}</span>
                      </div>
                    </div>
                    <button className="custom-btn-style-1 mt-3" type="submit">
                      {t("LOGIN")}
                    </button>

                  {telegramBotStatus && <section id="telegram-banner">
                    {telegramBanners && telegramBanners.length > 0 &&
                      <>
                        {telegramBanners.length > 1 ?
                          <div className="banner-slider">
                            <Slider {...telegramBannerSlick}>
                              {map(telegramBanners, (item, index) => {
                                return (
                                  <>
                                    <div
                                      key={index}
                                      className="banner-items"
                                      onClick={() => {
                                        if (!stringIsNullOrEmpty(item.url) && item.url !== "#") {
                                          handleBannerOnClick(item.url);
                                        }
                                        else {
                                          _dispatch(handleTelegramBannerOnClick());
                                        }
                                      }}>
                                      <img src={item.mobileImage} alt="banner" className="img-100" />
                                    </div>
                                  </>
                                )
                              })}
                            </Slider>
                          </div>
                          :
                          <div
                            className="banner-items"
                            onClick={() => {
                              if (!stringIsNullOrEmpty(telegramBanners[0].url) && telegramBanners[0].url !== "#") {
                                window.open(telegramBanners[0].url);
                              }
                              else {
                                _dispatch(handleTelegramBannerOnClick());
                              }
                            }}>
                            <img src={telegramBanners[0].mobileImage} alt="banner" className="img-100" />
                          </div>
                        }
                      </>
                    }
                    </section>}
                    <div className="text-center mt-3">
                      {t("DONT_HAVE_AN_ACCOUNT")} <span className="register_txt_btn" onClick={() => {
                        const code = getHostnameReferralCode(window.location.hostname);
                        if (code) {
                          window.location.href = `https://${window.location.hostname}/register?code=${code}`;
                        }
                        else {
                          _dispatch(setDisplayRegister(true)); _dispatch(setDisplayLogin(false))
                        }
                      }}>{t("REGISTER")}</span>
                    </div>
                    <div className="forgot_password_div">
                      <span className="forgot_password_txt_btn"
                        onClick={() => { _dispatch(setDisplayForgotPassword(true)); _dispatch(setDisplayLogin(false)); setIsForgetPassword(true) }}
                      >
                        {t("FORGOT_PASSWORD")}
                      </span>
                    </div>

                  </form>
                </div>
              </>

            }
            {isShowForgotPassword && !isLoggedIn && isForgetPassword && (

              <>
                <div className="auth-right-container">
                  <form onSubmit={forgotPasswordHandleSubmit(submitForgotPasswordForm)}>
                    <div className="font-16 mt-3">{t("USERNAME")}</div>
                    <input
                      type="text"
                      name="username"
                      id="username"
                      className="custom-input-style-1"
                      placeholder={t("USERNAME")}
                      autoComplete="off"
                      ref={forgotPasswordRegister({
                        required: true,
                      })}
                      errors={forgotPasswordErrors}
                    />
                    <button className="custom-btn-style-1 mt-4" type="submit">
                      {t("SEND_VIA_WHATSAPP")}
                    </button>
                    {forgotPasswordErrors.username && (
                      <div className="invalid-feedback">
                        {t(forgotPasswordErrors.username.message)}
                      </div>
                    )}
                  </form>
                </div>
              </>

            )}
            {isShowForgotPassword && !isLoggedIn && verifyPhoneTAC && (

              <>
                <div className="auth-right-container">
                  <form onSubmit={tacVerifyHandleSubmit(submitVerifyTAC)}>
                    <div className="font-16 mt-3">{t("OTP CODE")}</div>

                    <div className="auth-custom-pin-container mt-4">
                      <PinInput
                        length={6}
                        initialValue=""
                        secret={true}
                        autoSelect={true}
                        disabled={false}
                        type="numeric"
                        inputMode="number"
                        regexCriteria={/^[ 0-9_@./#&+-]*$/}
                        onChange={(e) => setEnteredPinNumber(e)}
                      />
                    </div>

                    <div className="tac_send" style={{ marginTop: '30px', textAlign: 'center' }}>
                      <div>{t("PHONE_OTP_SEND_TO") + " "}{tempPhoneNum}</div>
                      <button className="custom-btn-style-1" type="submit" onClick={() => verifyState.button = "1"}>
                        {t("CONTINUE")}
                      </button>
                      {countdownTime !== 0 &&
                        <div className="mt-3">
                          {t("RESET_CODE_IN_SECONDS", { value: moment.duration(countdownTime, 'milliseconds').asSeconds() })}
                        </div>
                      }

                      {forgetPasswordcountdownTAC && (
                        <div className="tac_send_again">
                          <button type="submit" onClick={() => verifyState.button = "2"}>
                            {t("DIDNT_RECEIVE_A_CODE")}
                          </button>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </>

            )}
            {isShowForgotPassword && !isLoggedIn && isUpdatePassword && (
              <>
                <div className="auth-right-container">

                  <form onSubmit={ResetPasswordHandleSubmit(submitNewPassword)}>
                    <div className="font-16 mt-3">{t("NEW_PASSWORD")}</div>
                    <div className="input-with-icon-container">
                      <input
                        type={newResetPasswordVisible ? "text" : "password"}
                        name="newPassword"
                        id="newPassword"
                        className="custom-input-style-1"
                        style={{ marginTop: '20px' }}
                        placeholder={t("NEW_PASSWORD")}
                        autoComplete="off"
                        ref={ResetPasswordRegister({
                          required: true,
                          minLength: {
                            value: _MIN_PASSWORD_LENGTH,
                            message: t("MIN_CHARACTERS", {
                              length: _MIN_PASSWORD_LENGTH,
                            }),
                          },
                          validate: (value) =>
                            watch("confPassword") == "" ||
                            value == watch("confPassword") ||
                            "PASSWORD_MISMATCH",
                        })}
                        errors={ResetPasswordErrors}
                      />
                      {ResetPasswordErrors.newPassword && (
                        <div className="invalid-feedback">
                          {t(ResetPasswordErrors.newPassword.message)}
                        </div>
                      )}
                      <div className="input-hidden-icon" onClick={toggleHiddenResetPassword}>
                        <img src={isHiddenResetPassword} alt="password" className="img-responsive" />
                      </div>
                    </div>
                    <div className="font-16 mt-3">{t("CONFIRM_NEW_PASSWORD")}</div>
                    <div className="input-with-icon-container">
                      <input
                        type={confirmResetPasswordVisible ? "text" : "password"}
                        name="confPassword"
                        id="confPassword"
                        className="custom-input-style-1"
                        style={{ marginTop: '20px' }}
                        placeholder={t("CONFIRM_NEW_PASSWORD")}
                        autoComplete="off"
                        ref={ResetPasswordRegister({
                          required: true,
                          minLength: {
                            value: _MIN_PASSWORD_LENGTH,
                            message: t("MIN_CHARACTERS", {
                              length: _MIN_PASSWORD_LENGTH,
                            }),
                          },
                          validate: (value) =>
                            watch("newPassword") == "" ||
                            value == watch("newPassword") ||
                            "PASSWORD_MISMATCH",
                        })}
                        errors={ResetPasswordErrors}
                      />
                      {ResetPasswordErrors.confPassword && (
                        <div className="invalid-feedback">
                          {t(ResetPasswordErrors.confPassword.message)}
                        </div>
                      )}
                      <div className="input-hidden-icon" onClick={toggleHiddenResetConfirmPassword}>
                        <img src={isHiddenResetConfirmPassword} alt="password" className="img-responsive" />
                      </div>
                    </div>
                    <button className="custom-btn-style-1" type="submit">
                      {t("RESET_PASSWORD")}
                    </button>
                  </form>
                </div>
              </>

            )}
            {isShowForgotPassword && !isLoggedIn && isPasswordUpdated && (
              <>
                <div className="auth-right-container">
                  <div className="reset_password_success">
                    <img
                      src={"/img/success_icon.svg"}
                      className="logout-white mt-3"
                      alt="white nav"
                    />
                    <div style={{ color: 'white', fontFamily: "Montserrat", size: '12px' }}>{t("RESET_PASSWORD_SUCCESS")}</div>
                    <button className="custom-btn-style-1" style={{ position: 'relative', top: '30px' }} onClick={() => handleCloseForgotPasswordModal()}>
                      {t("CLOSE")}
                    </button>
                  </div>
                </div>
              </>

            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isLoggedIn && isShowProfile}
        className="auth-popup-modal"
        toggle={() => {
          handleCloseProfileModal();
        }}
        fade={false}
      >
        <ModalBody>
          <div className="register-popup-wrapper">
            <div className="custom-close-modal">
              <div
                className="custom-close-button"
                onClick={() => {
                  handleCloseProfileModal();
                }}
              >
                <img
                  src={"/img/ug/auth/modal-close.png"}
                  alt="close"
                />
              </div>
              <div>
                {isLoggedIn && isShowProfile && t("MY_PROFILE")}
              </div>
            </div>
            <div className="side-menu-my-profile">
              <div className="side-menu-my-profile-first mt-4">
                {noticeIcons &&
                  noticeIcons.length &&
                  map(noticeIcons, (item, index) => {
                    return (
                      <div
                        key={index}
                        className="custom-icon-list-item-ug"
                        onClick={() => { handleCloseProfileModal(); _history.push(item.link); }}
                      >
                        <div className="first">
                          <img
                            src={item.image}
                            className="img-responsive"
                            alt="Withdrawal"
                          />
                        </div>
                        <div className="second">
                          {t(item.name)}
                        </div>

                      </div>
                    );
                  })
                }
              </div>
              <div className="swiper-container mt-4">
                <Swiper
                  spaceBetween={50}
                  slidesPerView={1}
                  navigation
                >
                  {walletInfo &&
                    walletInfo.map((item, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <div className="swiper-slide">
                            <div className="custom-icon-list-item-ug">
                              <div className="side-menu-profile-wallet">
                                <div className="first">
                                  {item.isCurrency &&
                                    <div>
                                      {t("IDR")}
                                    </div>
                                  }
                                  <div className="pl-2" onClick={() =>
                                    handleWalletClick(item)
                                  }>
                                    {item.balance}
                                  </div>
                                  {!item.isCurrency &&
                                    <div className="pl-2">
                                      {t("PT.")}
                                    </div>
                                  }
                                  <div className="refresh-wallet-icon pl-2" onClick={() => { item.name === "MAIN_WALLET" ? updateMemberWalletBalance() : (item.name === "COMMISSION" ? updateMemberUnclaimCommission() : (item.name === "REWARDS" ? updateMemberRewardData() : updateMemberLoyaltyPoints())) }}>

                                    {!item.refreshBalanceSpin &&
                                      <img className={`${item.refreshWalletIsSpining ? "rotate" : ""}`} src={refreshIconStatic} alt="balance update" width="100%" height="100%" />
                                    }

                                    {item.refreshBalanceSpin && !item.refreshWalletIsSpining &&
                                      <img src={gifSrc} alt="balance update" loading="lazy" width="100%" height="100%" />
                                    }

                                  </div>
                                </div>
                                <div className="second">
                                  {t(item.name)}
                                </div>

                                {item.name !== "MAIN_WALLET" && <div className="glint" >
                                  <div className="section-wrapper">
                                    <div className="button-wrapper" onClick={() =>
                                      handleWalletClick(item)
                                    }>
                                      <div className="button-icon">
                                        <div className="button-text">{t("VIEW_MORE")}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })
                  }
                  {/* Add more SwiperSlides as needed */}
                </Swiper>
              </div>
              <div className="mt-4">
                <div className="setting-downline-group-profile">
                  {TabDownline &&
                    TabDownline.length &&
                    map(TabDownline.filter((x) => (!isShareholder ? x.isShareHolder === false : x)), (item, index) => {
                      return (
                        <div
                          key={index}
                          className={tabDownlineActive == item.id ? "active" : "no-active"}
                          onClick={item.link ? () => window.location.href = item.link : () => setTabDownlineActive(item.id)}
                        >
                          {t(item.title)}
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              <div className="mt-4">
                {tabDownlineActive == 1 && (
                  <ProfileDetail />
                )}
                {tabDownlineActive == 2 && (
                  <ChangePassword />
                )}
                {tabDownlineActive == 3 && (
                  <ChangeShareHolderPin />
                )}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default Auth;